import React, { FC, KeyboardEvent, useState } from 'react';
import { Paper, InputBase, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from '@mui/material/CircularProgress';
import { ISearchInputProps } from './types';

export const SearchInput: FC<ISearchInputProps> = ({ onSearchResult, placeholder, loading }) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleSearch = () => {
    onSearchResult(searchTerm);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && searchTerm) {
      onSearchResult(searchTerm);
    }
  };

  return (
    <Paper
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
      }}
      className={'max-w-lg'}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ 'aria-label': placeholder }}
        value={searchTerm}
        onChange={event => setSearchTerm(event.target.value)}
        onKeyDown={handleKeyDown}
      />
      {loading ? (
        <IconButton sx={{ p: '10px' }} aria-label='search'>
          <CircularProgress size={24} />
        </IconButton>
      ) : (
        <IconButton sx={{ p: '10px' }} aria-label='search' onClick={handleSearch}>
          <SearchIcon />
        </IconButton>
      )}
    </Paper>
  );
};
